const React = require('react')
const PropTypes = require('prop-types')
const getActiveImage = require('module/user/helpers/get_active_image')
const getDisplayImage = require('module/user/helpers/get_display_image')
const getFallbackImage = require('module/user/helpers/get_fallback_image')
const { getCloudflareUrl } = require('@aboutdotme/image-helpers')
const Raven = require('lib/raven')
const config = require('lib/config')

// this component is used for the image on small templates. it is also used for
// the small circular image on the Account link in the Edit Panel. It accepts
// width/height as props, but defaults to 120x120, which is what the small
// template requires

class SmallImage extends React.Component {

    getStyle() {
        const { user, width, height } = this.props

        let url

        const has_image = getActiveImage(user)
        const image = getDisplayImage(user)
        const fallback = getFallbackImage()

        if (has_image) {
            try {
                url = getCloudflareUrl(image, {
                    width,
                    height,
                    quality: 40,
                    devicePixelRatio: 2,
                    image_domain: config.get('pumpkinhead.globals.aws_images'),
                })
            } catch (e) {
                Raven.captureException(e, {
                    extra: {
                        user_name: user.user_name,
                        image,
                    },
                })
                url = fallback.url
            }
        } else {
            url = fallback.url
        }

        const style = {
            width,
            height,
            backgroundImage: `url(${url})`,
            backgroundSize: 'cover',
            borderRadius: '50%',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center center',
        }

        return style
    }

    render() {
        const style = this.getStyle()

        return (
            <div className="image" style={style} />
        )
    }
}

SmallImage.propTypes = {
    user: PropTypes.shape({
        images: PropTypes.array,
    }).isRequired,
    width: PropTypes.number,
    height: PropTypes.number,
}

SmallImage.defaultProps = {
    width: 120,
    height: 120,
}

SmallImage.contextTypes = {
    globals: PropTypes.object.isRequired,
}

module.exports = SmallImage
